import { BalanceTransferFeature } from 'features';
import React from 'react';

const TransferToUserPage = () => {
  return <BalanceTransferFeature />;
};

export default TransferToUserPage;
